<template>
  <div class="container-fluid py-2 empresa-novedades-view">
    <div
      class="d-flex flex-wrap align-items-center justify-content-between mb-3 p-3 bg-white border rounded shadow-sm"
    >
      <div>
        <h5 class="mb-0 font-weight-bold">
          <i class="fas fa-sliders-h text-primary mr-2"></i>
          Novedades por línea de negocio
        </h5>
        <small class="text-muted d-block mt-1"
          >Cada fila es una novedad; elija líneas en el selector, valide y
          guarde.</small
        >
      </div>
      <button
        type="button"
        class="btn btn-primary shadow-sm px-4"
        @click="guardarNovedades()"
      >
        <i class="fas fa-save mr-1"></i>
        Guardar novedades
      </button>
    </div>

    <div class="alert alert-info mb-3 border-0" role="status">
      <i class="fas fa-lightbulb text-warning mr-2"></i>
      <span class="small">
        Use el selector <strong>Líneas de negocio</strong> (varias opciones) por
        fila; active <strong>Validar</strong> y la relevancia antes de guardar.
      </span>
    </div>

    <div class="row justify-content-center">
      <div
        class="col-xl-6 col-lg-6 mb-4"
        v-for="clase_novedad in listasForms.clase_novedades"
        :key="
          clase_novedad.numeracion ||
          clase_novedad.id ||
          clase_novedad.descripcion
        "
      >
        <div class="card h-100 shadow-sm border">
          <div
            class="card-header bg-primary text-white py-2 d-flex align-items-center justify-content-between"
          >
            <div
              class="d-flex align-items-center flex-grow-1 pr-2"
              style="min-width: 0"
            >
              <span class="badge badge-light text-primary mr-2 flex-shrink-0">
                {{ clase_novedad.numeracion || "-" }}
              </span>
              <span
                class="small font-weight-bold text-uppercase text-truncate mb-0"
                :title="clase_novedad.descripcion || '-'"
              >
                {{ clase_novedad.descripcion || "-" }}
              </span>
            </div>
            <button
              type="button"
              class="btn btn-sm btn-outline-light flex-shrink-0"
              data-toggle="collapse"
              :data-target="
                '#cnov-' + (clase_novedad.numeracion || clase_novedad.id || 'x')
              "
              :aria-expanded="true"
              :aria-controls="
                'cnov-' + (clase_novedad.numeracion || clase_novedad.id || 'x')
              "
              title="Mostrar u ocultar tabla"
            >
              <i class="fas fa-chevron-down"></i>
            </button>
          </div>

          <div
            class="collapse show"
            :id="
              'cnov-' + (clase_novedad.numeracion || clase_novedad.id || 'x')
            "
          >
            <div class="card-body p-0">
              <!-- GPS -->
              <div
                class="table-responsive overflow-auto"
                style="max-height: min(420px, 55vh)"
                v-if="clase_novedad.numeracion == 1"
              >
                <table
                  class="table table-sm table-striped table-hover table-bordered mb-0 text-center"
                >
                  <thead class="thead-dark">
                    <tr>
                      <th class="text-center">#</th>
                      <th>Novedad</th>
                      <th class="text-center">Líneas de negocio</th>
                      <th class="text-center">Validar</th>
                      <th class="text-center">Relevancia</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(nov, i) in listasForms.novedadesGPS"
                      :key="nov.novedad || nov.numeracion || nov.id || i"
                    >
                      <td class="text-center align-middle">
                        <span class="badge badge-secondary">{{ i + 1 }}</span>
                      </td>
                      <td class="small text-capitalize align-middle">
                        {{ nov.descripcion }}
                      </td>
                      <td class="align-middle p-2" style="min-width: 12rem">
                        <div class="w-100">
                          <v-select
                            multiple
                            :options="listasForms.lineas_negocio"
                            label="nombre"
                            :reduce="(ln) => ln.id"
                            v-model="nov.lineas_negocio_ids"
                            placeholder="Elegir líneas…"
                            class="vs-lineas-novedad"
                            @input="onLineasNegocioChange(nov)"
                          />
                        </div>
                      </td>
                      <td class="text-center">
                        <div class="custom-control custom-switch">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="
                              idSwitchNovedad(clase_novedad.numeracion, nov, i)
                            "
                            v-model="nov.permite"
                            @change="
                              [
                                (nov.relevancia = 1),
                                (nov.switchRelevante = false),
                                (nov.nomRelevancia = nombreRelevancia(1)),
                              ]
                            "
                          />
                          <label
                            class="custom-control-label"
                            :for="
                              idSwitchNovedad(clase_novedad.numeracion, nov, i)
                            "
                          >
                          </label>
                        </div>
                      </td>
                      <td class="text-center">
                        <div
                          class="custom-control custom-switch"
                          :class="
                            nov.permite
                              ? 'custom-switch-off-warning custom-switch-on-danger'
                              : ''
                          "
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="
                              idSwitchRelevante(
                                clase_novedad.numeracion,
                                nov,
                                i
                              )
                            "
                            v-model="nov.switchRelevante"
                            :disabled="!nov.permite"
                            @change="cambiaRelevancia(nov)"
                          />
                          <label
                            class="custom-control-label"
                            :for="
                              idSwitchRelevante(
                                clase_novedad.numeracion,
                                nov,
                                i
                              )
                            "
                            >{{ nov.nomRelevancia }}</label
                          >
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Rutas -->
              <div
                class="table-responsive overflow-auto"
                style="max-height: min(420px, 55vh)"
                v-else-if="clase_novedad.numeracion == 2"
              >
                <table
                  class="table table-sm table-striped table-hover table-bordered mb-0 text-center"
                >
                  <thead class="thead-dark">
                    <tr>
                      <th
                        class="text-center text-white-50"
                        style="width: 2.25rem"
                        title="Número de fila (1 = primera novedad de la lista)"
                      >
                        #
                      </th>
                      <th>Novedad</th>
                      <th style="min-width: 13rem">Líneas de negocio</th>
                      <th class="col-1 text-center">Validar</th>
                      <th class="col-1 text-center">Relevancia</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(nov, i) in listasForms.novedadesRutas"
                      :key="nov.novedad || nov.numeracion || nov.id || i"
                    >
                      <td class="text-center">
                        <span
                          class="badge badge-secondary"
                          :title="'Fila ' + (i + 1)"
                          >{{ i + 1 }}</span
                        >
                      </td>
                      <td class="small text-capitalize align-middle">
                        {{ nov.descripcion }}
                      </td>
                      <td class="align-middle p-2" style="min-width: 12rem">
                        <div class="w-100">
                          <v-select
                            multiple
                            :options="listasForms.lineas_negocio"
                            label="nombre"
                            :reduce="(ln) => ln.id"
                            v-model="nov.lineas_negocio_ids"
                            placeholder="Elegir líneas…"
                            class="vs-lineas-novedad"
                            @input="onLineasNegocioChange(nov)"
                          />
                        </div>
                      </td>
                      <td class="text-center">
                        <div class="custom-control custom-switch">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="
                              idSwitchNovedad(clase_novedad.numeracion, nov, i)
                            "
                            v-model="nov.permite"
                            @change="
                              [
                                (nov.relevancia = 1),
                                (nov.switchRelevante = false),
                                (nov.nomRelevancia = nombreRelevancia(1)),
                              ]
                            "
                          />
                          <label
                            class="custom-control-label"
                            :for="
                              idSwitchNovedad(clase_novedad.numeracion, nov, i)
                            "
                          >
                          </label>
                        </div>
                      </td>
                      <td class="text-center">
                        <div
                          class="custom-control custom-switch"
                          :class="
                            nov.permite
                              ? 'custom-switch-off-warning custom-switch-on-danger'
                              : ''
                          "
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="
                              idSwitchRelevante(
                                clase_novedad.numeracion,
                                nov,
                                i
                              )
                            "
                            v-model="nov.switchRelevante"
                            :disabled="!nov.permite"
                            @change="cambiaRelevancia(nov)"
                          />
                          <label
                            class="custom-control-label"
                            :for="
                              idSwitchRelevante(
                                clase_novedad.numeracion,
                                nov,
                                i
                              )
                            "
                            >{{ nov.nomRelevancia }}</label
                          >
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Inspecciones -->
              <div class="p-4" v-else-if="clase_novedad.numeracion == 3">
                <div
                  class="alert alert-light border mb-0 text-center small text-muted"
                >
                  <i class="fas fa-info-circle text-info mr-1"></i>
                  Esta sección no está disponible.
                </div>
              </div>
              <!-- Geocercas -->
              <div
                class="table-responsive overflow-auto"
                style="max-height: min(420px, 55vh)"
                v-else-if="clase_novedad.numeracion == 4"
              >
                <table
                  class="table table-sm table-striped table-hover table-bordered mb-0"
                >
                  <thead class="thead-dark">
                    <tr>
                      <th
                        class="text-center text-white-50"
                        style="width: 2.25rem"
                        title="Número de fila (1 = primera novedad de la lista)"
                      >
                        #
                      </th>
                      <th>Novedad</th>
                      <th style="min-width: 13rem">Líneas de negocio</th>
                      <th class="col-1 text-center">Validar</th>
                      <th class="col-1 text-center">Relevancia</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(nov, i) in listasForms.novedadesGeocercas"
                      :key="nov.novedad || nov.numeracion || nov.id || i"
                    >
                      <td class="text-center">
                        <span
                          class="badge badge-secondary"
                          :title="'Fila ' + (i + 1)"
                          >{{ i + 1 }}</span
                        >
                      </td>
                      <td class="small text-capitalize align-middle">
                        {{ nov.descripcion }}
                      </td>
                      <td class="align-middle p-2" style="min-width: 12rem">
                        <div class="w-100">
                          <v-select
                            multiple
                            :options="listasForms.lineas_negocio"
                            label="nombre"
                            :reduce="(ln) => ln.id"
                            v-model="nov.lineas_negocio_ids"
                            placeholder="Elegir líneas…"
                            class="vs-lineas-novedad"
                            @input="onLineasNegocioChange(nov)"
                          />
                        </div>
                      </td>
                      <td class="text-center">
                        <div class="custom-control custom-switch">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="
                              idSwitchNovedad(clase_novedad.numeracion, nov, i)
                            "
                            v-model="nov.permite"
                            @change="
                              [
                                (nov.relevancia = 1),
                                (nov.switchRelevante = false),
                                (nov.nomRelevancia = nombreRelevancia(1)),
                              ]
                            "
                          />
                          <label
                            class="custom-control-label"
                            :for="
                              idSwitchNovedad(clase_novedad.numeracion, nov, i)
                            "
                          >
                          </label>
                        </div>
                      </td>
                      <td class="text-center">
                        <div
                          class="custom-control custom-switch"
                          :class="
                            nov.permite
                              ? 'custom-switch-off-warning custom-switch-on-danger'
                              : ''
                          "
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="
                              idSwitchRelevante(
                                clase_novedad.numeracion,
                                nov,
                                i
                              )
                            "
                            v-model="nov.switchRelevante"
                            :disabled="!nov.permite"
                            @change="cambiaRelevancia(nov)"
                          />
                          <label
                            class="custom-control-label"
                            :for="
                              idSwitchRelevante(
                                clase_novedad.numeracion,
                                nov,
                                i
                              )
                            "
                            >{{ nov.nomRelevancia }}</label
                          >
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "EmpresaNovedades",
  components: {
    vSelect,
  },
  data() {
    return {
      empresa_id: this.$parent.form.id,
      guardando: false,
      seleccionesNovedades: [],
      listasForms: {
        clase_novedades: [],
        relevancias: [],
        lineas_negocio: [],
        novedadesGPS: [],
        novedadesRutas: [],
        novedadesGeocercas: [],
      },
      configsEmpresa: null,
    };
  },
  methods: {
    lineasNegocioIdsKey(nov) {
      const a = Array.isArray(nov.lineas_negocio_ids)
        ? nov.lineas_negocio_ids
        : [];
      return (
        a
          .slice()
          .map((x) => Number(x))
          .sort((x, y) => x - y)
          .join("-") || "n"
      );
    },

    idSwitchNovedad(numeracion, nov, i) {
      const sid = nov.novedad ?? nov.numeracion ?? nov.id ?? i;
      return `switchNovedad_${numeracion}_${sid}_${this.lineasNegocioIdsKey(
        nov
      )}`;
    },

    idSwitchRelevante(numeracion, nov, i) {
      const sid = nov.novedad ?? nov.numeracion ?? nov.id ?? i;
      return `switchRelevante_${numeracion}_${sid}_${this.lineasNegocioIdsKey(
        nov
      )}`;
    },

    getConfigLinea(c) {
      return c?.linea_negocio_id ?? c?.lineaNegocioId ?? null;
    },

    aplicarConfigAItem(item, tipoNovedadEsperado) {
      const configs = Array.isArray(this.configsEmpresa)
        ? this.configsEmpresa
        : [];
      const getItemId = (it) => it?.novedad ?? it?.numeracion ?? it?.id ?? null;
      const getConfigTipo = (c) => c?.tipo_novedad ?? c?.tipoNovedad ?? null;
      const getConfigSub = (c) =>
        c?.sub_novedad ?? c?.subNovedad ?? c?.novedad ?? null;

      const id = getItemId(item);
      if (id == null) return;

      const candidatos = configs.filter((c) => {
        const tipoOK =
          tipoNovedadEsperado == null
            ? true
            : getConfigTipo(c) != null
            ? Number(getConfigTipo(c)) === Number(tipoNovedadEsperado)
            : true;
        const subOK =
          getConfigSub(c) != null && String(getConfigSub(c)) === String(id);
        return tipoOK && subOK;
      });

      const lineasDesdeConfigs = [
        ...new Set(
          candidatos
            .map((c) => this.getConfigLinea(c))
            .filter((v) => v != null && v !== "")
            .map((v) => Number(v))
        ),
      ];

      let lineasIds = [];
      if (lineasDesdeConfigs.length) {
        lineasIds = lineasDesdeConfigs;
      } else if (candidatos.length > 0) {
        lineasIds = this.listasForms.lineas_negocio.map((l) => l.id);
      }

      this.$set(item, "lineas_negocio_ids", lineasIds);

      const permite = candidatos.length > 0;
      const sortedCand = [...candidatos].sort(
        (a, b) =>
          Number(this.getConfigLinea(a) || 0) -
          Number(this.getConfigLinea(b) || 0)
      );
      const ref = sortedCand[0];
      const relevancia = ref != null ? ref.relevancia ?? 1 : 1;
      const switchRelevante = permite && Number(relevancia) === 2;
      const nomRelevancia = permite
        ? this.nombreRelevancia(relevancia)
        : "Advertencia";

      this.$set(item, "permite", permite);
      this.$set(item, "relevancia", relevancia);
      this.$set(item, "switchRelevante", switchRelevante);
      this.$set(item, "nomRelevancia", nomRelevancia);
    },

    onLineasNegocioChange(nov) {
      const raw = Array.isArray(nov.lineas_negocio_ids)
        ? nov.lineas_negocio_ids
        : nov.lineas_negocio_ids == null
        ? []
        : [nov.lineas_negocio_ids];
      const seen = new Set();
      const normalized = [];
      for (const x of raw) {
        if (x == null || x === "") continue;
        const n = Number(x);
        if (Number.isNaN(n)) continue;
        if (!seen.has(n)) {
          seen.add(n);
          normalized.push(n);
        }
      }
      // Nuevo arreglo para que Vue 2 detecte altas/bajas al quitar chips en v-select
      this.$set(nov, "lineas_negocio_ids", normalized);
      if (normalized.length === 0) {
        this.$set(nov, "permite", false);
      } else if (!nov.permite) {
        this.$set(nov, "permite", true);
      }
      this.$nextTick(() => {
        this.seleccionesNovedades = this.armarPayloadNovedades();
      });
    },

    armarPayloadNovedades() {
      const mapTipo = (numeracion) => numeracion;
      const relBase = (n) => n.relevancia ?? (n.switchRelevante ? 2 : 1);
      const armaPorTipo = (tipoNovedad, lista) => {
        if (!Array.isArray(lista)) return [];
        const out = [];
        for (const n of lista) {
          if (!n || !n.permite) continue;
          const ids = Array.isArray(n.lineas_negocio_ids)
            ? n.lineas_negocio_ids
            : [];
          for (const lineaId of ids) {
            if (lineaId == null || lineaId === "") continue;
            const ln = (this.listasForms.lineas_negocio || []).find(
              (x) => Number(x.id) === Number(lineaId)
            );
            out.push({
              empresa_id: this.empresa_id,
              tipo_novedad: mapTipo(tipoNovedad),
              sub_novedad: n.novedad ?? n.numeracion ?? n.id ?? null,
              relevancia: relBase(n),
              linea_negocio_id: Number(lineaId),
              linea_negocio_nombre: ln?.nombre ?? null,
            });
          }
        }
        return out;
      };

      return [
        ...armaPorTipo(1, this.listasForms.novedadesGPS),
        ...armaPorTipo(2, this.listasForms.novedadesRutas),
        ...armaPorTipo(4, this.listasForms.novedadesGeocercas),
      ];
    },

    tienePermiteSinLineas(lista) {
      return (lista || []).some(
        (n) =>
          n &&
          n.permite &&
          (!Array.isArray(n.lineas_negocio_ids) ||
            n.lineas_negocio_ids.length === 0)
      );
    },

    guardarNovedades() {
      if (
        this.tienePermiteSinLineas(this.listasForms.novedadesGPS) ||
        this.tienePermiteSinLineas(this.listasForms.novedadesRutas) ||
        this.tienePermiteSinLineas(this.listasForms.novedadesGeocercas)
      ) {
        this.$swal({
          icon: "warning",
          title:
            "Marque al menos una línea de negocio en cada novedad con Validar activo.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
        return;
      }

      this.$parent.cargando = true;
      const payload = this.armarPayloadNovedades();
      this.seleccionesNovedades = payload;

      axios({
        method: "PUT",
        url: `/api/admin/empresas/saveNovedadesConfig`,
        data: payload,
      })
        .then((response) => {
          this.getIndex();
          this.$swal({
            icon: "success",
            title: "Las novedades se guardaron exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.$parent.cargando = false;
        })
        .catch((e) => {
          this.$parent.cargando = false;
          this.$swal({
            icon: "error",
            title:
              "Ha ocurrido un error, por favor intente la acción nuevamente.",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    getIndex() {
      axios
        .get(`/api/admin/empresas/novedadesConfig/${this.empresa_id}`, {
          params: {},
        })
        .then((response) => {
          this.getForm(response.data);
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    getForm(conf) {
      this.configsEmpresa = conf;
      (this.listasForms.novedadesGPS || []).forEach((item) =>
        this.aplicarConfigAItem(item, 1)
      );
      (this.listasForms.novedadesRutas || []).forEach((item) =>
        this.aplicarConfigAItem(item, 2)
      );
      (this.listasForms.novedadesGeocercas || []).forEach((item) =>
        this.aplicarConfigAItem(item, 4)
      );
    },

    getNovedades() {
      axios
        .get("/api/lista/157", {
          params: { in_number: [1, 2, 4] },
        })
        .then((response) => {
          this.listasForms.clase_novedades = response.data;
        });
    },

    getRevelancias() {
      axios.get("/api/lista/149").then((response) => {
        this.listasForms.relevancias = response.data;
      });
    },

    getLineasNegocio() {
      axios
        .get("/api/admin/lineasNegocios/lista", {
          params: {
            in_number: [2, 3, 4, 5],
          },
        })
        .then((response) => {
          this.listasForms.lineas_negocio = response.data || [];
          if (this.configsEmpresa) this.getForm(this.configsEmpresa);
        });
    },

    nombreRelevancia(relevancia) {
      const num = Number(relevancia);
      const search = this.listasForms.relevancias.find(
        (r) => Number(r.numeracion) === num
      );
      return search ? search.descripcion : "Advertencia";
    },

    cambiaRelevancia(nov) {
      if (!nov) return;
      const relevancia = nov.switchRelevante ? 2 : 1;
      // Asegura reactividad si los campos no existían antes.
      this.$set(nov, "relevancia", relevancia);
      this.$set(nov, "nomRelevancia", this.nombreRelevancia(relevancia));
    },

    getNovedadesGPS() {
      axios
        .get("/api/lista/158", {
          params: {
            in_number: [1, 2, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
          },
        })
        .then((response) => {
          this.listasForms.novedadesGPS = (response.data || []).map((row) => ({
            ...row,
            lineas_negocio_ids: Array.isArray(row.lineas_negocio_ids)
              ? row.lineas_negocio_ids
              : [],
          }));
          if (this.configsEmpresa) this.getForm(this.configsEmpresa);
        });
    },

    getNovedadesRutas() {
      axios.get("/api/lista/159").then((response) => {
        this.listasForms.novedadesRutas = (response.data || []).map((row) => ({
          ...row,
          lineas_negocio_ids: Array.isArray(row.lineas_negocio_ids)
            ? row.lineas_negocio_ids
            : [],
        }));
        if (this.configsEmpresa) this.getForm(this.configsEmpresa);
      });
    },

    getNovedadesGeocercas() {
      axios.get("/api/lista/225").then((response) => {
        this.listasForms.novedadesGeocercas = (response.data || []).map(
          (row) => ({
            ...row,
            lineas_negocio_ids: Array.isArray(row.lineas_negocio_ids)
              ? row.lineas_negocio_ids
              : [],
          })
        );
        if (this.configsEmpresa) this.getForm(this.configsEmpresa);
      });
    },
  },

  mounted() {
    this.getNovedades();
    this.getRevelancias();
    this.getLineasNegocio();
    this.getNovedadesGPS();
    this.getNovedadesRutas();
    this.getNovedadesGeocercas();
    this.getIndex();
  },
};
</script>

<style scoped>
.empresa-novedades-view {
  max-width: 1600px;
  margin-left: auto;
  margin-right: auto;
}

.vs-lineas-novedad {
  min-width: 0;
}

::v-deep .vs-lineas-novedad .vs__dropdown-toggle {
  min-height: calc(1.5em + 0.75rem + 2px);
  padding: 0.25rem 0.5rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background-color: #fff;
}

::v-deep .vs-lineas-novedad.vs--open .vs__dropdown-toggle,
::v-deep .vs-lineas-novedad .vs__dropdown-toggle:focus-within {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

::v-deep .vs-lineas-novedad .vs__selected-options {
  flex-wrap: wrap;
}

::v-deep .vs-lineas-novedad .vs__selected {
  margin: 2px 4px 2px 0;
  padding: 0.125rem 0.5rem;
  border-radius: 0.2rem;
  font-size: 0.8125rem;
  background-color: #e7f1ff;
  border: 1px solid #b8daff;
  color: #004085;
}

::v-deep .vs-lineas-novedad .vs__search {
  margin: 2px 0 0 2px;
}
</style>
